<style lang="scss" scoped>
.testimonial-row {
    position: relative;
    height: 560px;

    > div {
        height: 560px;
    }

    h3 {
        max-width: 294px;
    }

    &:after {
        content: "";
        background-color: #fff;
        display: block;
        position: absolute;
        left: calc(50% + 118px);
        height: 100%;
        width: 100vw;
    }

    .overlaying {
        position: relative;
        z-index: 1;
    }
}

.testimonial-image {
    min-height: 400px;

    img {
        object-fit: cover;
        font-family: "object-fit: cover;";
        border-radius: 4px;
    }
}

.testimonial-slider-image {
    width: 282px;
    height: 560px;
    position: relative;
    min-height: 0;

    .image-wrapper {
        position: absolute;
        bottom: 0;
        height: 275px;
        transition: height 0.3s;
    }

    &.large {
        .image-wrapper {
            height: 560px;
        }
    }
}

.slider-wrapper {
    position: relative;
    margin-right: 100px;
}

.custom-controls {
    position: absolute;
    bottom: 0;
    right: 14px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;

    span {
        display: inline-block;

        &:after {
            transition: left 0.2s;
        }

        &:hover {
            &:after {
                left: 8px;
            }
        }
    }

    .prev {
        transform: rotate(180deg);
        margin-right: 8px;

        &:after {
            position: relative;
            width: 26px;
            height: 11px;
            top: -5px;
            left: 0;
            content: url("/svg/arrow-left-black.svg");
        }

        &:hover {
            &:after {
                transform: translateX(8px) rotate(180deg);
            }
        }
    }
    .next {
        &:after {
            position: relative;
            width: 26px;
            height: 11px;
            left: 0;
            content: url("/svg/arrow-right-black.svg");
        }
    }
}

.wrapper-desktop {
    ::v-deep .tns-outer {
        position: absolute;
        bottom: 0;
        right: calc(-50vw - 150px);
        width: 100vw;
        height: 100%;
        .tns-ovh {
            position: absolute;
            bottom: 0;
            overflow: visible;
        }
    }
}

.wrapper-mobile {
    .custom-controls {
        position: relative;
        margin-left: 24px;
        bottom: unset;
        right: unset;

        .prev {
            &:after {
                top: -3px;
            }
        }
    }
}

.wrapper-mobile,
.wrapper-desktop {
    ::v-deep .tns-outer {
        .tns-controls {
            display: none !important;
            position: absolute;
            z-index: 2;
            bottom: -10px;
            left: calc(50%);
            outline: none !important;

            button {
                position: relative;
                visibility: hidden;
                outline: none !important;
                padding: 0;
                border: 0;

                &:after {
                    visibility: visible;
                    position: absolute;
                    width: 26px;
                    height: 11px;
                    left: 0;
                    transition: transform 0.2s;
                }
            }

            button:first-child {
                transform: rotate(180deg);

                &:after {
                    content: url("/svg/arrow-left-black.svg");
                }

                &:hover {
                    &:after {
                        transform: translateX(8px);
                    }
                }
            }

            button:last-child {
                margin-left: 12px;

                &:after {
                    top: -1px;
                    left: -1px;
                    content: url("/svg/arrow-right-black.svg");
                }

                &:hover {
                    &:after {
                        transform: translateX(8px);
                    }
                }
            }
        }
    }
}

.testimonial-content {
    position: absolute;
    top: 0;
    height: 560px;
    background-color: #fff;
}

blockquote {
    font-style: italic;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;

    @media screen and (max-width: 1023.98px) {
        font-size: 1.5rem;
        line-height: 1.2;
    }
}

.author {
    font-size: 1rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div v-if="!isMobile" class="testimonials-wrapper wrapper-desktop">
        <div v-if="testimonials.length > 1" class="container-fluid position-absolute">
            <div class="row testimonial-row">
                <div class="col-12 col-md-8 position-relative">
                    <div class="slider-wrapper h-100">
                        <div class="testimonials-slider">
                            <div v-for="(testimonial, index) in testimonials" :key="testimonial.id">
                                <div class="testimonial-slider-image testimonial-image" :data-index="index">
                                    <div class="image-wrapper d-flex">
                                        <img class="img-fluid w-100" :src="testimonial.acf.images[0].sizes.medium_large" :alt="testimonial.post_title">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div v-if="testimonials.length == 1 && activeTestimonial != null" class="row large-gutters">
                <div class="col-12">
                    <h3 class="mb-40">{{ title }}</h3>
                </div>
                <div class="col-12 col-lg-6 mb-32 mb-lg-0">
                    <div class="d-flex w-100 h-100 testimonial-image">
                        <img class="img-fluid w-100" :src="activeTestimonial.acf.images[0].sizes.medium_large" :alt="activeTestimonial.post_title">
                    </div>
                </div>
                <div class="col-12 col-lg-6 d-flex flex-column justify-content-center py-lg-40">
                    <transition name="fade">
                        <div v-if="activeTestimonial != null" :key="activeTestimonial.id" class="w-100 d-flex align-items-start flex-column justify-content-center">
                            <img v-if="activeTestimonial.acf.company_logo" class="mb-24" :src="activeTestimonial.acf.company_logo.url" :alt="activeTestimonial.post_title">
                            <blockquote class="mb-16">{{ activeTestimonial.acf.quote }}</blockquote>
                            <span class="d-block author font-weight-light" v-html="activeTestimonial.post_title"></span>
                            <a v-if="activeTestimonial.acf.story != null && activeTestimonial.acf.story.length > 0" :href="route('nl.story', {'slug': activeTestimonial.acf.story[0].post_name})" class="btn btn-accent mt-40">Lees het verhaal</a>
                        </div>
                    </transition>
                </div>
            </div>
            <div v-if="testimonials.length > 1" class="row testimonial-row">
                <div class="col-12 col-md-8 position-relative">
                    <h3 class="position-absolute">{{ title }}</h3>
                </div>
                <div class="col-12 col-md-4 overlaying">
                    <transition name="fade">
                        <div v-if="activeTestimonial != null" :key="activeTestimonial.id" class="testimonial-content w-100 d-flex align-items-start flex-column justify-content-center">
                            <img v-if="activeTestimonial.acf.company_logo" class="mb-24" :src="activeTestimonial.acf.company_logo.url" :alt="activeTestimonial.post_title">
                            <blockquote class="mb-16">{{ activeTestimonial.acf.quote }}</blockquote>
                            <span class="d-block author font-weight-light" v-html="activeTestimonial.post_title"></span>
                            <a v-if="activeTestimonial.acf.story != null && activeTestimonial.acf.story.length > 0" :href="route('nl.story', {'slug': activeTestimonial.acf.story[0].post_name})" class="btn btn-accent mt-40">Lees het verhaal</a>
                        </div>
                    </transition>

                    <div class="custom-controls">
                        <span class="prev" @click="previousSlide"></span>
                        <span class="next" @click="nextSlide"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="wrapper-mobile">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-40">{{ title }}</h3>
                </div>
            </div>
        </div>
        <div class="testimonials-slider">
            <div v-for="testimonial in testimonials" :key="testimonial.id">
                <img class="img-fluid w-100 mb-40" :src="testimonial.acf.images[0].sizes.medium_large" :alt="testimonial.post_title">
                <div class="d-flex flex-column justify-content-center py-lg-40">
                    <transition name="fade">
                        <div class="w-100 px-24 d-flex align-items-start flex-column justify-content-center">
                            <img v-if="testimonial.acf.company_logo" class="mb-24" :src="testimonial.acf.company_logo.url" :alt="testimonial.post_title">
                            <blockquote class="mb-16">{{ testimonial.acf.quote }}</blockquote>
                            <span class="d-block author font-weight-light" v-html="testimonial.post_title"></span>
                            <a v-if="testimonial.acf.related_story != null && testimonial.acf.related_story.length > 1" :href="route('nl.story', {'slug': testimonial.acf.related_story[0].slug})" class="btn btn-accent mt-40">Lees het verhaal</a>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="custom-controls mt-24">
            <span class="prev" @click="previousSlide"></span>
            <span class="next" @click="nextSlide"></span>
        </div>
    </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider.module"

export default {
    name: "pagePart.testimonial-row",

    props: {
        testimonials: {
            type: Array,
            required: true,
            default: () => {
                return []
            },
        },

        title: {
            type: String,
            required: true
        },
    },

    data: () => ({
        slider: null,
        activeIndex: null,
        activeTestimonial: null,
        isMobile: false
    }),

    mounted() {
        this.isMobile = window.innerWidth < 1024
        this.$nextTick().then(() => {
            if (this.isMobile) this.handleMobileInit()
            else this.handleDesktopInit()
        })
    },

    methods: {
        handleMobileInit() {
            this.slider = tns({
                container: '.testimonials-slider',
                slideBy: 1,
                autoplay: false,
                gutter: 0,
                nav: false,
                controls: true,
                navPosition: 'bottom',
                mouseDrag: false,
                navAsThumbnails: true,
                loop: false,
                rewind: true,
                center: true
            });
        },
        handleDesktopInit() {
            if (this.testimonials.length > 0) {
                this.activeTestimonial = this.testimonials[this.testimonials.length - 1];
                this.activeIndex = this.testimonials.length - 1;
            }

            if (this.testimonials.length > 1) {
                this.updateSlideClasses();

                this.slider = tns({
                    container: '.testimonials-slider',
                    items: this.testimonials.length,
                    slideBy: 1,
                    autoplay: false,
                    autoWidth: true,
                    gutter: 24,
                    nav: false,
                    controls: true,
                    navPosition: 'bottom',
                    startIndex: this.activeIndex,
                    mouseDrag: false,
                    navAsThumbnails: true,
                    loop: false,
                    rewind: true,
                    center: true
                });

                this.slider.events.on('indexChanged', (event) => {
                    this.activeIndex = this.slider.getInfo().displayIndex - 1;
                    this.activeTestimonial = this.testimonials[this.activeIndex];
                    this.updateSlideClasses();
                })
            }
        },
        updateSlideClasses() {
            var slides = document.getElementsByClassName("testimonial-slider-image");
            for (var i = 0; i < slides.length; i++) {
                var slide = slides[i];
                slide.classList.remove('large');

                if (slide.dataset.index == this.activeIndex) {
                    slide.classList.add('large');
                }
            }
        },

        previousSlide() {
            document.querySelector('.tns-controls button:last-child').click();
        },

        nextSlide() {
            document.querySelector('.tns-controls button:first-child').click();
        }
    },

    computed: {
        getActiveIndex() {
            return this.activeIndex;
        }
    }
}
</script>
